export class AbcEmailForm {
  public fullName : string;
  public emailAddress: string;
  public phoneNumber: number;
  public message : string;
}
